import { Search } from 'lucide-react';
import { useSupport } from '../../../../../../../context/support/SupportContext';

const ChatListHeader = ({ chatCount }) => {
  const { chatSearchTerm, setChatSearchTerm, chatFilter, setChatFilter } = useSupport();

  return (
    <div className="p-4 bg-white border-b border-gray-200 space-y-3">
      <div className="flex items-center justify-between">
        <h2 className="text-xs font-bold text-gray-500 uppercase tracking-wider">
          Active Travellers ({chatCount})
        </h2>
        <div className="flex gap-1 bg-gray-100 p-0.5 rounded-lg text-[10px] font-bold">
          <button
            onClick={() => setChatFilter('all')}
            className={`px-2.5 py-1 rounded-md transition-all cursor-pointer ${
              chatFilter === 'all' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500'
            }`}
          >
            All
          </button>
          <button
            onClick={() => setChatFilter('unread')}
            className={`px-2.5 py-1 rounded-md transition-all cursor-pointer ${
              chatFilter === 'unread' ? 'bg-[#067978] text-white shadow-sm' : 'text-gray-500'
            }`}
          >
            Unread
          </button>
        </div>
      </div>

      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={14} />
        <input
          type="text"
          placeholder="Search guest or 5-char booking ID..."
          value={chatSearchTerm}
          onChange={(e) => setChatSearchTerm(e.target.value)}
          className="w-full pl-9 pr-3 py-2 bg-gray-100 border-none rounded-xl text-xs font-medium outline-none focus:ring-2 focus:ring-[#067978]/30"
        />
      </div>
    </div>
  );
};

export default ChatListHeader;
